import { useRouter } from 'next/router';

const addCurrentQueryParams = (
  targetUrl: string,
  currentQueryParams?: Record<string, string | Array<string> | undefined>,
): string => {
  if (!targetUrl) {
    return '';
  }

  const [baseUrl, existingQuery] = targetUrl.split('?');
  const targetParams = new URLSearchParams(existingQuery || '');

  Object.entries(currentQueryParams || {}).forEach(([key, value]) => {
    if (value && !targetParams.has(key)) {
      const stringValue = Array.isArray(value) ? value[0] : value;
      targetParams.set(key, stringValue);
    }
  });

  const queryString = targetParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export const useAddCurrentQueryParams = () => {
  const router = useRouter();

  return (targetUrl: string): string => {
    return addCurrentQueryParams(targetUrl, router.query);
  };
};
